import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import Feature from './feature-module/feature';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { base_path } from './environment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import './style/css/feather.css';
import './style/icon/tabler-icons/webfont/tabler-icons.css';
import './index.scss';
import { store } from './store';
import { Provider, useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './style/icon/boxicons/boxicons/css/boxicons.min.css';
import './Airoom.css';
import { ToastContainer } from 'react-toastify';
import { DirtyStateProvider } from './core/common/ConfirmationModaltsx/DirtyStateContext';
import { useRenewTokenMutation } from './services/EndPointsApis';
import { setUser } from './Features/authslice';
import { useFormik } from 'formik';

const App = () => {

 
  return (
    <BrowserRouter basename={base_path}>
      <DirtyStateProvider>
        <Feature />
      </DirtyStateProvider>
      <ToastContainer autoClose={3000} />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
